export default __webpack_public_path__ + "static/media/bet-and-earn-banner-cn.01c7d9e6.webp";